/**
 * GDPR Data Portability: request a copy of the user's data.
 */

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1';

const getAuthToken = () => localStorage.getItem('token');

/**
 * Request data export. Returns JSON data on success.
 * On 429 (rate limit), throws an error with message and optional retryAfterSeconds.
 */
export async function exportMyData(): Promise<Record<string, unknown>> {
  const token = getAuthToken();
  const response = await fetch(`${API_BASE_URL}/users/me/export`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
      ...(token && { Authorization: `Bearer ${token}` }),
    },
    cache: 'no-store',
  });

  const text = await response.text();
  let body: { error?: string; retryAfterSeconds?: number } = {};
  try {
    body = JSON.parse(text);
  } catch {
    // non-JSON response
  }

  if (response.status === 429) {
    const err = new Error(body.error || 'You can request one export per 24 hours. Please try again later.') as Error & { retryAfterSeconds?: number };
    err.retryAfterSeconds = body.retryAfterSeconds;
    throw err;
  }

  if (!response.ok) {
    throw new Error(body.error || `Export failed (${response.status})`);
  }

  try {
    return JSON.parse(text) as Record<string, unknown>;
  } catch {
    throw new Error('Invalid export response');
  }
}
